import React, { Component, useState } from 'react';
import { Grid, ListItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Typo from '../../components/CustomTypo';
import { ArrowDownIcon } from '../../components/icons';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import classNames from 'classnames'
const styles = theme => ({
    container: {
        padding: theme.spacing(3, 3, 3, 3)
    },
    product_image_cover: {
        width: '100%',
        height: 400,
        containFit: 'cover'
    },
    product_item_container: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    product_item: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.shape.borderRadius2x,
        padding: theme.spacing(3, 5, 3, 5),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        border: "2px solid",
        borderColor: theme.palette.background.secondary,
        cursor:'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
            marginBottom: 0,
        },
    },
    product_item_selected: {
        backgroundColor: theme.palette.background.secondary,
        borderTopLeftRadius: theme.shape.borderRadius2x,
        borderTopRightRadius: theme.shape.borderRadius2x,
        borderBottom: "1px solid",

        borderBottomColor: theme.palette.border.primary,
        padding: theme.spacing(3, 5, 3, 5),
        marginTop: theme.spacing(2),
        marginBottom: 0,
        cursor:'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
            marginBottom: 0,
        },
    },
    menuItem: {
        backgroundColor: theme.palette.background.secondary,
        borderBottomLeftRadius: theme.shape.borderRadius2x,
        borderBottomRightRadius: theme.shape.borderRadius2x,
    },
    price:{
        position:'absolute',
        right: theme.spacing(3)
    },
    border_require:{
        borderColor: theme.palette.background.icon,
    }
})
function ComponentItemsView(props) {
    const [listItemToShow, setListItemToShow] = useState(null);

    const onShowListItem = (parentId) =>{
        if (listItemToShow && listItemToShow === parentId)
            setListItemToShow(null)
        else
            setListItemToShow(parentId)
    }
    const onSelectItem = (component, product) =>{
        setListItemToShow(null)
        props.onSelectComponent(component, product)
    }
    const checkSelectedItem = (component) =>{
        var productSelected = [];
        var componentsSelected = props.componentsSelected;

        if (componentsSelected.length > 0) {
            componentsSelected.forEach(selected => {
                if (selected.id === component.id) {
                    productSelected = selected.productSelected
                }
            });
        }
        return productSelected;
    }
    const checkRequire = (componentRequireSelected, component) =>{
        var isRequire = false;
        if (componentRequireSelected && componentRequireSelected.length > 0) {
            var findComponent = componentRequireSelected.filter(c => {
                return c.id == component.id;
            })
            if (findComponent && findComponent.length > 0) {
                isRequire = true;
            }
        }
        return isRequire;
    }
    const renderComponents = (components, classes, t, componentRequireSelected) =>{
        var componentsView = [];
        components.forEach((component, index) => {
            var productSelected = checkSelectedItem(component);
            //console.log("components:",components);
            var isRequire = productSelected.length > 0 ? false : checkRequire(componentRequireSelected, component);
            //console.log('renderComponents==== isRequire: ',isRequire)
            componentsView.push(
                <div>
                    <Grid xs={12} item container direction="row" key={index}
                        className={classNames(listItemToShow == component.id ? classes.product_item_selected : classes.product_item,isRequire ? classes.border_require : undefined)}
                        aria-controls="customized-menu"
                        aria-haspopup="true"
                        onClick={() => product_type ==='FIXED_BUNDLE'? null:onShowListItem(component.id)}
                    >
                        <Grid xs={10} item>
                            <Typo variant="subtitle2">{component.display_name ? component.display_name : component.name}</Typo>
                            {productSelected.length > 0 ? productSelected.map((p,index) => {
                                return <Typo variant="body1">{p.name}</Typo>
                            }) : <Typo color={isRequire?"error":"default"} variant="body1">{t('None')}</Typo>}
                        </Grid>
                        <Grid xs={2} item container alignItems='center' justify='flex-end'>
                            {product_type ==='FIXED_BUNDLE'&& productSelected.length > 0 ? productSelected.map((p,index) => {
                                var price = dataUtil.getProductPrice(p.pricing);
                                return <Typo variant="body1" mg_top_xl>{props.currency}{price}</Typo>
                            }) :
                            <ArrowDownIcon />}
                        </Grid>
                    </Grid>
                    {renderProducts(component, classes, productSelected)}
                </div>
            )
        });
        return componentsView;
    }

    const renderProducts = (component, classes, productSelected) =>{
        var componentsView = null;
        if (listItemToShow === component.id) {
            var products = component.products ? component.products : [];

            componentsView = products.map((product, index) => {
                //console.log('renderProducts product===',product)
                var price = dataUtil.getProductPrice(product.pricing);

                var filterProducts = productSelected.filter(p => {
                    return p.id == product.id
                });
                var isSelected = filterProducts && filterProducts.length > 0 ? true : false;

                //console.log('renderProducts price===',price)
                return (
                    <ListItem button={true} key={index} onClick={() =>  onSelectItem(component, product)}>
                        <Typo variant="body1" color={isSelected?'error':'primary'}>{product.name}</Typo>
                        {price ? <div className={classes.price}>
                            <Typo variant="subtitle2" color={isSelected?'error':'primary'}>{props.currency}{dataUtil.getProductPrice(product.pricing).toFixed(2)}</Typo>
                        </div> : null}
                    </ListItem>
                )
            })
        }
        if (componentsView) {
            return (<Grid xs={12} item className={classes.menuItem}>
                {componentsView}
            </Grid>)
        }
        return <Grid />
    }
    const { components, classes, componentsSelected, t, componentRequireSelected, product_type } = props;
        return (
            <div>
                {renderComponents(components, classes, t, componentRequireSelected, product_type)}
            </div>
        );
    
}

export default withStyles(styles)(withTranslation()(ComponentItemsView));